module.exports = __webpack_public_path__ + "static/media/GROKCAT-BNB.481bf1f1.png";